<script setup lang="ts">
import MetabaseIframe from '@/views/dashboard/Components/MetabaseIframe.vue'
import LegacyDashboardBanner from '@/components/dashboard/LegacyDashboardBanner.vue'

const { t } = useI18n()

const pageTitle = {
  title: 'pages.dashboard.businessDashboardPage.title'
}
</script>

<template>
  <MetabaseIframe :dashboard="103">
    <template #header>
      <div class="px-6 pt-6 sm:px-12 sm:pt-8">
        <LegacyDashboardBanner />
      </div>
      <TheListHeader :title="t(pageTitle.title)" />
    </template>
  </MetabaseIframe>
</template>
